import {NgModule} from '@angular/core';
import {LoanAgreementComponent} from './loanAgreement.component';
import {LoanAgreementTextComponent} from './loanAgreementText.component';
import {MatDialogModule} from '@angular/material/dialog';
import {MatButtonModule} from '@angular/material/button';

@NgModule({
    imports: [MatDialogModule, MatButtonModule],
    exports: [LoanAgreementComponent, LoanAgreementTextComponent],
    declarations: [LoanAgreementComponent, LoanAgreementTextComponent]
})
export class LoanAgreementModule {
}